import React, { lazy, Suspense, useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { commonHooks } from 'hooks';
import { generatePath, Link, matchPath } from 'react-router-dom';
import { getLazyName } from 'helpers/i18n';

const Guide = lazy(() =>
  import('teko-help-center').then(mod => ({ default: mod.Guide }))
);

const { useCurrentRoute, usePathname } = commonHooks;

const AppBreadcrumb: React.FC = () => {
  const pathname = usePathname().pathname;
  const { matchedRoutes, currentRoute } = useCurrentRoute();
  const shouldRender = currentRoute && !currentRoute.hideBreadcrumb;
  const match = matchPath(pathname, {
    path: currentRoute?.path,
    exact: currentRoute?.exact,
  });

  // linkableRoutes could be dynamic routes. Thus, matched params need to be mapped into them.
  const linkableRoutes = matchedRoutes
    .filter(route => !!route.component)
    .map(route => {
      if (match) {
        return { ...route, path: generatePath(route.path, match.params) };
      }
      return route;
    });

  useEffect(() => {
    if (linkableRoutes.length > 0) {
      document.title = getLazyName(
        linkableRoutes[linkableRoutes.length - 1].name
      );
    }
  }, [linkableRoutes]);

  if (!shouldRender) return null;

  return (
    <div className="d-flex align-items-center">
      <Breadcrumb className="app-breadcrumb">
        {linkableRoutes.map(item => (
          <Breadcrumb.Item key={item.path}>
            {currentRoute?.path !== item.path ? (
              <Link to={item.path}>{getLazyName(item.name)}</Link>
            ) : (
              getLazyName(item.name)
            )}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
      {currentRoute?.guide && (
        <div className="app-guide">
          <Suspense fallback={<div>Loading guide...</div>}>
            <Guide
              type="popup"
              popupProps={{ width: 1000 }}
              {...currentRoute.guide}
            />
          </Suspense>
        </div>
      )}
    </div>
  );
};

export default AppBreadcrumb;
